import { render } from "./ManageSubjectModal.vue?vue&type=template&id=46808453&scoped=true"
import script from "./ManageSubjectModal.js?vue&type=script&lang=js"
export * from "./ManageSubjectModal.js?vue&type=script&lang=js"

import "./ManageSubjectModal.vue?vue&type=style&index=0&id=46808453&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46808453"]])

export default __exports__